import CoursePackageForm from "./CoursePackageForm";
export default function UpdateCoursePackage() {
  return <CoursePackageForm mode="edit" />;
}